import {Variable} from '../models/variable';
import {AssessmentResult} from '../../shared/models/assessment-result';
import { IReportItemComponent } from "app/reports/models/i-report-item-component";
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import { AfterViewInit } from '@angular/core';

export abstract class BaseReportItemComponent implements IReportItemComponent, AfterViewInit {
    private _loadSubject:BehaviorSubject<boolean>;
    constructor() {
        this._loadSubject = new BehaviorSubject<boolean>(false);
    }

    abstract setReportData(data: any, results: AssessmentResult[], variables: Variable[]);

    protected notifyItemLoad() {
        this._loadSubject.next(true);
        this._loadSubject.complete();
    }
    protected notifyItemLoadFailed() {
        this._loadSubject.next(false);
        this._loadSubject.complete();
    }

    public ngAfterViewInit() {
        // console.log("ngAfterViewInit called with ", this);
        this.notifyItemLoad();
    }
    public itemLoaded() : Observable<boolean> {
        return this._loadSubject.asObservable();
    }
    public getHTMLClassNames() : string[] {
        return [];
    }
}


// WEBPACK FOOTER //
// ./src/app/reports/models/base-report-item-component.ts